export default __webpack_public_path__ + "static/media/donor.d4a87bb2.png";